import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CustomerInformation} from "./customer-information";
import {environment} from "../../../../environments/environment";
import {
  ClaimVerifiedCustomerInformationDto
} from "../../../auto-generated-server-dtos/customer-information/map/claim-verified-customer-information-dto";

@Injectable({
  providedIn: 'root'
})
export class GetCustomerInformationService {

  constructor(private httpClient: HttpClient) { }

  getCustomerInformation(applicationId: number): Observable<ClaimVerifiedCustomerInformationDto> {
    return this.httpClient.get<ClaimVerifiedCustomerInformationDto>(`${environment.apiServer}/GetCustomerInformation`, {params: {applicationId: applicationId}});
  }
}
